<template>
  <div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" class="inline-oil">
    <!-- <h5>油卡余额不足</h5> -->
    <table class="dataintable">

      <tr class="tab_header">
        <td>序号</td>
        <td class="long1_3 left">油卡编号</td>
        <td class="short0 cen">油卡类型</td>
        <td class="long1 left">车牌</td>
        <td class="short0">当前余额</td>
        <td class="short0">警告金额</td>
      </tr>
      <tr v-for="(item, index) in list_oil" :key="index">
        <td>{{ item.id }}</td>
        <td class="long1_3 left">{{ item.item_no }}</td>
        <td class="short0 cen">{{item.oil_class}}</td>
        <td class="long1 left">{{item.car_no}}</td>
        <td class="short0">{{ item.amount_n }}元</td>
        <td class="short0">{{ item.amount_f }}元</td>
      </tr>
    </table>
  </div>
</template>

<script>
  import api from '@/utils/type.js'

  import {
    Method_EasySelect,
    Method_EasyAdd
  } from '@/utils/loadhttpdata.js';

  export default {
    name: "oil",
    data() {
      return {
        element_loading: false,

        list_oil: []




      };
    },
    created: function() {
      // console.log('油卡 组件 创建');
      // this.loaddata();
    },
    mounted: function() {
      // console.log('油卡 组件 mounted');
      this.loaddata();
    },
    // activated: function() {
    //   console.log('油卡 组件激活时调用 激活');

    // },
    methods: {
      loaddata: function() {
        this.element_loading = true;
        this.list_oil = [];
        this.$post(
          api.http_method, Method_EasySelect('data_exp_warningoil')
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {
            let t = res.data.data;
            console.log(t[0]);
            this.list_oil = t[0].yk_detail;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });
      },
    }


  }
</script>

<style scoped="scoped">
  .inline-oil {
    display: inline-block;
    min-height: calc(100vh - 120px);
    max-height: calc(100vh - 120px);
    overflow: auto;
    vertical-align: top;
  }

  .tab_header td {
    /* 纵向渐变 */
    /* Safari 5.1 - 6.0 */
    background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
    /* Opera 11.1 - 12.0 */
    background: -o-linear-gradient(#3da5d9, #a2d2ff);
    /* Firefox 3.6 - 15 */
    background: -moz-linear-gradient(#3da5d9, #a2d2ff);
    /* 标准的语法（必须放在最后） */
    background: linear-gradient(#3da5d9, #a2d2ff);
    text-align: center;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }
</style>
